import { render } from "./RoomStudentList.vue?vue&type=template&id=66826ec4&scoped=true&ts=true"
import script from "./RoomStudentList.vue?vue&type=script&lang=ts"
export * from "./RoomStudentList.vue?vue&type=script&lang=ts"

import "./RoomStudentList.vue?vue&type=style&index=0&id=66826ec4&lang=scss&scoped=true"

import exportComponent from "/Users/kameyamanaoki/dev/mingaku/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66826ec4"]])

export default __exports__